import styled from '@emotion/styled';

export const FooterContainer = styled.footer`
  background-color: #292f36;
  padding: 140px 26px 50px 26px;
  max-width: 1400px;
  width: 100%;
  margin: auto;
  @media (max-width: 600px) {
    padding: 50px 26px;
    display: flex;
    flex-direction: column;
  }
`;

export const LogoAppStoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 50px;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const AnchorLogo = styled.img`
  align-self: center;
  width: 120px;
  @media (max-width: 600px) {
    margin-bottom: 46px;
  }
`;

export const Rule = styled.hr`
  margin: 0;
  margin-bottom: 40px;
  border: 1px solid #fff;
  opacity: 0.2;
  width: 100%;
  @media (max-width: 600px) {
    margin-bottom: 46px;
  }
`;

export const AppLinksContainer = styled.div`
  flex: 0 0 300px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex: 0;
  }
`;

export const LinksAndSocialContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const CopyrightContainer = styled.p`
  opacity: 0.8;
  color: #c9cbcd;
  font-size: 1.4rem;
  @media (max-width: 600px) {
    text-align: center;
  }
`;

export const LinksContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 446px;
  @media (max-width: 1024px) {
    width: 100%;
    margin-bottom: 50px;
  }
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    height: 170px;
    margin-bottom: 46px;
  }
`;

export const SocialContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 120px;
  @media (max-width: 600px) {
    margin: auto;
    margin-bottom: 46px;
  }
`;

export const TabletWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
